
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationProjectHeadline: {
    id: "ConfigurationProject.headline",
    defaultMessage: "Which object does your configuration belong to?",
  },
  configurationProjectTabExisting: {
    id: "ConfigurationProject.tabexisting",
    defaultMessage: "Select existing object",
  }, 
  configurationProjectTabNew: {
    id: "ConfigurationProject.tabnew",
    defaultMessage: "Define new object",
  },
  configurationProjectTabEXISTING: {
    id: "ConfigurationProject.tabEXISTING",
    defaultMessage: "EXISTING",
  },
  configurationProjectTabNEW: {
    id: "ConfigurationProject.tabNEW",
    defaultMessage: "NEW",
  },
  configurationProjectTabWITHOUT: {
    id: "ConfigurationProject.tabWITHOUT",
    defaultMessage: "WITHOUT",
  },
});

export default MESSAGES;